<template>
  <div>
    <b-card title="الیاسل 🚀">
      <b-card-text>شروعی پر قدرت.</b-card-text>
      <b-card-text>به ما بپیوندید <b-link
        href="#"
        target="_blank"
      >

      </b-link> و بهترین باشید!</b-card-text>
    </b-card>

    <!-- <b-card title="Want to integrate JWT? 🔒">
      <b-card-text>We carefully crafted JWT flow so you can implement JWT with ease and with minimum efforts.</b-card-text>
      <b-card-text>Please read our  JWT Documentation to get more out of JWT authentication.</b-card-text>
    </b-card> -->
  </div>
</template>

<script>
import { BCard, BCardText, BLink } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardText,
    BLink,
  },
}
</script>

<style>

</style>
